import { useEffect, useRef, useState } from "react";
import { getLocale, shallowEqual, useSelector } from "umi";
import moment from "moment";
import { downLoadPcConsoleV2DayPerformanceTable, getPcConsoleV2DayPerformanceTable } from "@/pages/dashboard/services/overview";
import { LANGUAGE_MAP, PERIODTIMEOBJ } from "@/pages/dashboard/_config/constant";
import { IsSingleDay } from "@/pages/dashboard/utils/utils";
import { PagingQuery } from "tea-component";
import { SortBy } from "./types";
import { getTableRequestParams } from "./hooks";

const useData = (
  filterValue: any,
  filterLoading: boolean,
  selectType:string,
  // getRequestParams: Function,
) => {

  // 加载状态
  const [loading, setLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);
  // // 分页
  const [paging, setPaging] = useState<PagingQuery>({ pageSize: 10, pageIndex: 1 });
  // // 排序
  const [sort, setSort] = useState<SortBy[]>([])
  // 总条数
  const [total, setTotal] = useState(0)

  // 表格数据
  const [tableData, setTableData] = useState([])

  // 聚合数据
  const [statisticsData, setStatisticsData] = useState([])

  // const [,forceUpdate] = useReducer(x=>x+1,0)
  const filterValueSort = useRef(filterValue);
  const accumulateOldValueRef = useRef(['date'])

  const gameCode = useSelector( (state:any)=> state?.dashboard?.currentGame?.game_code,shallowEqual)

  // 获取表格上传参数
  const getRequestParams = (paging: any, sort: any,filterValue:any, otherParams?: any) => {
    // overview页面的日期上传参数逻辑与其他页面不同, 故特殊处理
    const { filterValue: filterVal, newFilter, diff } = filterValue;
    let startTime = filterVal?.rangeTime?.[0];
    let endTime = filterVal?.rangeTime?.[1];
    let periodObj = { period: 'daily'}

    /**
     * day 少于七天补足七天
     * week 少于六周补足六周
     * month 少于六月补足六月
     */
    if (newFilter && diff) {
      switch (filterValue.timeType) {
        case "Day": {
          startTime = moment().subtract(8, 'day').format('YYYY-MM-DD')
          break;
        }
        case "Week": {
          startTime = moment(endTime).subtract(5, 'week').format('YYYY-MM-DD')
          break;
        }
        case "Month": {
          startTime = moment(startTime).subtract(5, 'month').format('YYYY-MM-DD')
          break;
        }
      }
    }

    return getTableRequestParams({
      gameCode, filterValue,
      accumulated: accumulateOldValueRef?.current,
      sort: sort,
      paging: paging,
      selectType,
      start_date: moment(startTime).format("YYYYMMDD"),
      end_date: moment(endTime).format("YYYYMMDD"),
      ...otherParams,
      ...periodObj
    })
  }

  useEffect(() => {
    filterValueSort.current = { filterValue, paging }
  }, [filterValue, paging,sort])

  // 点击筛选器的时候
  useEffect(() => {
    if (filterLoading) return;
    setPaging({ pageIndex: 1, pageSize: paging.pageSize });
    setSort([])
    const params = getRequestParams({ pageIndex: 1, pageSize: paging.pageSize }, [],filterValue)
    getTableData(params);

  }, [filterValue, filterLoading])


  const getTableData = (params: any) => {
    setIsError(false);
    setLoading(true);
    getPcConsoleV2DayPerformanceTable(params, LANGUAGE_MAP[getLocale()]).then((resp) => {
      setLoading(false);
      setTableData(resp.metrics_list || [])
      setStatisticsData(resp.aggregation || [])
      // 设置总条数
      setTotal(resp.row_count)
    }).catch(e => {
      setLoading(false)
      setIsError(true);
      console.log("overview 宽表请求错误: ", filterValue.timeType, e);
    })
  }


  return {
    tableData,
    statisticsData,
    paging,
    loading,
    isError,
    sort,
    total,
    filterValueSort,
    accumulateOldValueRef,
    isSingle: IsSingleDay({ ...filterValue, period: PERIODTIMEOBJ[filterValue?.timeType] }),
    setPaging,
    setSort,
    getRequestParams,
    getData: getTableData,
    downLoadData: downLoadPcConsoleV2DayPerformanceTable
  }
}

export default useData;